import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ModalBody } from 'reactstrap';
import WindcreekModal from 'components/WindcreekModal';
import { CALL_CENTER_PHONE_NUMBERS } from 'utils/constants';
import PhoneNumber from 'components/PhoneNumber';
import { getRequestId } from 'utils/requestId';

const showStackTrace =
  process.env.REACT_APP_SHOW_ERROR_STACKTRACE === 'true' ||
  process.env.REACT_APP_SHOW_ERROR_STACKTRACE === true;

const StackTraceWrapper = styled.div`
  padding: 1rem;
  background: ${props => props.theme.colors.lightGrey};
  max-height: 20rem;
  overflow: auto;
  text-align: left;
  margin-top: 3rem;
`;

const RequestIdWrapper = styled.p`
  font-size: 0.7em;
`;

const propTypes = {
  property: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  error: PropTypes.node,
  componentStack: PropTypes.string,
  modalClassName: PropTypes.string,
  children: PropTypes.node,
  page: PropTypes.shape({
    height: PropTypes.string,
    scrollY: PropTypes.string
  })
};

const defaultProps = {
  isOpen: false,
  title: 'An error has occurred',
  modalClassName: 'error-modal'
};

function ErrorModal({
  isOpen,
  title,
  error,
  componentStack,
  children,
  modalClassName,
  property,
  page
}) {
  const errorId = getRequestId();

  return (
    <WindcreekModal
      modalClassName={modalClassName}
      isOpen={isOpen}
      page={page}
      centered
      autoFocus
    >
      <ModalBody>
        <h1>{title}</h1>

        {children ? (
          children
        ) : (
          <React.Fragment>
            <p>Please refresh to try again in a few minutes.</p>
            <p>
              If the issue persists, please call{' '}
              <PhoneNumber value={CALL_CENTER_PHONE_NUMBERS[property]} /> to
              complete your booking.
            </p>
          </React.Fragment>
        )}

        {showStackTrace && errorId && (
          <RequestIdWrapper>
            <strong>ERROR ID</strong>: {errorId}
          </RequestIdWrapper>
        )}

        {showStackTrace && error && (
          <StackTraceWrapper>
            <h5>Stacktrace (shown in development/test environment only)</h5>

            {componentStack && (
              <React.Fragment>
                <pre>{error.toString() + componentStack}</pre>
                <hr />
              </React.Fragment>
            )}

            <pre>
              {error instanceof Error ? error.stack || error.toString() : error}
            </pre>
          </StackTraceWrapper>
        )}
      </ModalBody>
    </WindcreekModal>
  );
}

ErrorModal.propTypes = propTypes;
ErrorModal.defaultProps = defaultProps;

export default ErrorModal;
